import { useState } from "react"
import './OracleLkmAwards.css'
import HangingMenus from './components/HangingMenus.jsx';

const OracleLkmAwards = () => {            
    const [activeArena, setActiveArena] = useState(1);

    return (        
        <>
            <div className="oracle-awards-banner">
                <img src={process.env.PUBLIC_URL + "/images/Oracle/awards/banner.png"} alt="Awards Banner" />
            </div>
            
            <div className="oracle-awards-body">
                <div className="oracle-awards-content">
                    <p>
                        The Hall of Fame page highlights and honors individuals who have excelled in the Oracle Power Up League Program 
                        and Certification. It serves as a platform to recognize their dedication, achievements, and expertise, inspiring 
                        others to strive for excellence in Oracle technologies.
                    </p>
                </div>                        
                <div className="oracle-awards-arena-block">
                    <div className="oracle-awards-arena-inner-block">
                        <div className="oracle-awards-arena-inner-block-num">02</div>
                        <div className="oracle-awards-arena-inner-block-text">Arena - 01</div>
                    </div>
                    <hr />
                    <div className="oracle-awards-arena-inner-block">
                        <div className="oracle-awards-arena-inner-block-num">35</div>
                        <div className="oracle-awards-arena-inner-block-text">Arena - 02</div>
                    </div>                
                    <hr />
                    <div className="oracle-awards-arena-inner-block">
                        <div className="oracle-awards-arena-inner-block-num">27</div>
                        <div className="oracle-awards-arena-inner-block-text">Arena - 03</div>
                    </div>
                </div>                        
                <div className="oracle-awards-tabs">
                    {[1, 2, 3].map((arena) => (                    
                        <>
                            <div
                                key={arena}
                                className={`oracle-awards-tab ${activeArena === arena ? "active" : ""}`}
                                onClick={() => setActiveArena(arena)}
                            >
                                Arena - 0{arena}
                                <div key={arena} className={`oracle-awards-arrow-down ${activeArena === arena ? "active" : ""}`}></div>                                            
                            </div>                        
                        </>
                    ))}                                
                </div>
                <div className="oracle-awards-cards-block">
                    <div className="oracle-awards-cards">
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image1.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image3.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image4.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>  
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image5.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image6.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>                      
                    </div>
                    <div className="oracle-awards-cards">
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image1.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image3.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image4.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>  
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image5.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>
                        <div class="oracle-awards-card">
                            <div class="oracle-awards-cards-top">
                                <img class="oracle-awards-cards-trophy" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image6.png"} alt="trophy" />
                                <img class="oracle-awards-cards-profile-img" src={process.env.PUBLIC_URL + "/images/Oracle/awards/image2.png"} alt="profile" />
                            </div>
                            <div class="oracle-awards-cards-bottom">
                                <h3>Tanvi Satish Mondkar</h3>
                                <p>Quality Engineering Specialist</p>
                            </div>
                        </div>                      
                    </div>                    
                </div>                          
            </div>            
            
            <HangingMenus />
        </>        
    );
};

export default OracleLkmAwards